module.exports = __webpack_public_path__ + "static/fipcbrownsafarimain-848e5d765a0e91e35ab0ace1dc409ce7.jpeg";